<template>
  <main class="w-full m-auto contact mb-6">
    <div v-if="done" class="w-full max-w-[570px] leading-6 m-auto text-center">
      <h2 class="text-xl mt-12 py-6 text-green-700 font-bold">
        Votre demande de contact a bien été prise en compte
      </h2>
      <p class="font-bold text-[#273A60] mb-4">
        Nous avons bien reçu votre demande, elle sera traitée avec la plus
        grande attention. Nous vous contacterons dans les plus brefs délais
      </p>
      <p class="font-bold italic py-6">
        A trés bientot dans votre point de vente ou sur
        <a
          href="https://www.husqvarna.com/fr/"
          class="text-[#273A60]"
          target="_blank"
          >https://www.husqvarna.fr/</a
        >
      </p>
    </div>

    <form v-else class="mx-3 flex">
      <div
        class="pt-6 pb-4 mb-2 flex flex-wrap justify-between max-w-3xl m-auto"
      >
        <h2 class="uppercase text-lg font-bold text-center w-full">
          CONTACTEZ-NOUS
        </h2>

        <div class="w-full">
          <div class="f-item" :class="{ error_field: error.society }">
            <label for="society"> Raison Sociale</label>
            <input
              @input="error.society = ''"
              :disabled="loadingState"
              v-model="form.society"
              id="society"
              type="text"
            />
            <span v-if="error.society" class="error">*{{ error.society }}</span>
          </div>
        </div>

        <div class="w-full md:w-[49%]">
          <div class="f-item" :class="{ error_field: error.lastname }">
            <label for="lastname"> Nom * </label>
            <input
              @input="error.lastname = ''"
              :disabled="loadingState"
              required
              v-model="form.lastname"
              id="lastname"
              type="text"
            />
            <span v-if="error.lastname" class="error"
              >*{{ error.lastname }}</span
            >
          </div>
        </div>

        <div class="w-full md:w-[49%]">
          <div class="f-item" :class="{ error_field: error.firstname }">
            <label for="firstname"> Prénom * </label>
            <input
              @input="error.firstname = ''"
              :disabled="loadingState"
              required
              v-model="form.firstname"
              id="firstname"
              type="text"
            />
            <span v-if="error.firstname" class="error"
              >*{{ error.firstname }}</span
            >
          </div>
        </div>

        <div class="w-full md:w-[49%]">
          <div class="f-item" :class="{ error_field: error.email }">
            <label for="email"> Email * </label>
            <input
              @input="error.email = ''"
              :disabled="loadingState"
              required
              v-model="form.email"
              class="w-full"
              id="email"
              type="email"
            />
            <span v-if="error.email" class="error">*{{ error.email }}</span>
          </div>
        </div>

        <div class="w-full md:w-[49%]">
          <div
            class="f-item"
            :class="{ error_field: error.email_confirmation }"
          >
            <label for="email_confirmation"> Confirmation email * </label>
            <input
              @input="error.email_confirmation = ''"
              :disabled="loadingState"
              required
              v-model="form.email_confirmation"
              class="w-full"
              id="email_confirmation"
              type="email"
            />
            <span v-if="error.email_confirmation" class="error"
              >*{{ error.email_confirmation }}</span
            >
          </div>
        </div>

        <div class="w-full">
          <div class="f-item" :class="{ error_field: error.operation }">
            <label for="operation"> Opération concernée * </label>
            <select
              :disabled="loadingState || loadingOperations"
              required
              id="operation"
              name="contact[operation]"
              class="form-control"
              v-model="form.operation"
              @change="onOperationChange"
            >
              <option value="">-- Sélectionnez une opération --</option>
              <option v-for="op in operations" :key="op._id" :value="op.title">{{ op.title }}</option>
            </select>
            <span v-if="error.operation" class="error">*{{ error.operation }}</span>
          </div>
        </div>

        <div class="w-full">
          <div class="f-item" :class="{ error_field: error.objet }">
            <label for="status"> Votre demande * </label>

            <select
              :disabled="loadingState"
              required
              id="status"
              name="contact[statut]"
              class="form-control form-control"
              v-model="form.objet"
            >
              <option>Problème technique lors de ma participation</option>
              <option>Je n'arrive pas à télécharger mes preuves d'achat</option>
              <option>Le site de l'offre ne fonctionne pas</option>
              <option>
                Je n'arrive pas à suivre le traitement de mon dossier de
                participation
              </option>
              <option>
                Le lien de suivi de ma participation ne fonctionne pas
              </option>
              <option>Le montant de mon remboursement n'est pas correct</option>
              <option>Demande d'information sur l'offre</option>
              <option>
                Mon ou mes produit(s) est (sont)-il(s) éligible(s) à l'offre?
              </option>
              <option>Autre</option>
            </select>
            <span v-if="error.objet" class="error">*{{ error.objet }}</span>
          </div>
        </div>

        <div class="w-full">
          <div
            class="f-item !items-start mb-4"
            :class="{ error_field: error.message }"
          >
            <label for="contact_message" class="pt-2"> Message * </label>
            <textarea
              @input="error.message = ''"
              id="contact_message"
              name="message"
              required="required"
              class="form-control form-control h-36"
              v-model="form.message"
            ></textarea>
            <span v-if="error.message" class="error">*{{ error.message }}</span>
          </div>
        </div>

        <div class="w-full">
          <div class="w-full text-center">
            <button
              v-if="!loadingState"
              @click.prevent="getResult"
              class="button"
            >
              envoyer ma demande
            </button>
            <button
              v-if="loadingState"
              class="button !bg-gray-400 !text-white flex items-center justify-center m-auto"
            >
              <div
                class="inline-block h-5 w-5 animate-spin rounded-full border-2 mr-3 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                role="status"
              ></div>
              Chargement...
            </button>
          </div>
        </div>
      </div>
    </form>
  </main>
</template>

<script>
import axios from "axios";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export default {
  data: function () {
    return {
      error: {},
      loadingState: false,
      loadingOperations: false,
      operations: [],
      operationsId: [
        { _id: "68760d9231332264387c136e" },
        { _id: "68907ff8b745780eb4643fe1" },
        { _id: "6939885452a281612e7ea5c5" },
        { _id: "693989b9a310d81c44e73407" },
        { _id: "696fa1e827dd902d7e2e459d" },

      ],
      required_field: [
        "lastname",
        "firstname",
        "operation",
        "objet",
        "email",
        "message",
        "email_confirmation",
      ],
      operationId: "",
      idgame: "",
      subid: "",
      uid: "",
      done: false,
      form: {
        objet: "Je souhaite connaitre le suivi de mon dossier",
        operation: "",
        youare: "Particulier",
        civilite: "MME",
        addr: {},
      },
    };
  },
  async mounted() {
    try {
      this.operationId = localStorage.getItem("operationId") || "";
      this.idgame = localStorage.getItem("idgame") || "";
      this.subid = localStorage.getItem("subid") || null;
      this.uid = localStorage.getItem("subid") || null;

      this.scrollToTop();
      this.fetchOperations();

      if (this.subid != null && this.uid != null) {
        let { data: submission } = await axios.get(
          `https://api.husqvarna-promo.fr/api/v2/submissions/${this.subid}?uid=${this.uid}`
        );

        if (submission) {
          this.form = {
            society: submission.company_name,
            subid: this.subid,
            operationId: this.operationId,
            lastname: submission.last_name,
            firstname: submission.first_name,
            email: submission.email,
            email_confirmation: submission.email,
          };
        }
      }
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    onOperationChange() {
      this.error.operation = '';
      const selectedOp = this.operations.find(op => op.title === this.form.operation);
      if (selectedOp) {
        this.idgame = selectedOp.idgame || '';
        this.operationId = selectedOp._id || '';
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    isRequired(value) {
      return value ? true : "Ce champ est requis";
    },
    isDateBetween(startDate, endDate) {
      const todayStart = dayjs().startOf('day');
      const todayEnd = dayjs().endOf('day');
      const start = dayjs(startDate, "DD/MM/YYYY").startOf('day');
      const end = dayjs(endDate, "DD/MM/YYYY").endOf('day');

      // date_debut 00h00 <= aujourd'hui 00h00 ET aujourd'hui 23h59 <= date_fin 23h59
      return !todayStart.isBefore(start) && !todayEnd.isAfter(end);
    },
    async fetchOperation(_id) {
      try {
        const response = await fetch(
          `https://api.husqvarna-promo.fr/api/v2/formdata/${_id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Erreur HTTP: ${response.status}`);
        }

        const data = await response.json();

        // Transformer le titre comme sur la homepage
        data.title = data.title.includes(" - ") ? data.title.split(" - ")[1] : data.title;
        data.date_debut = dayjs(data.date_debut).locale("fr").format("DD/MM/YYYY");
        data.date_fin = dayjs(data.date_fin).locale("fr").format("DD/MM/YYYY");

        // Vérifier si l'opération est active
        const isActive = this.isDateBetween(data.date_debut, data.date_fin);
        data.isActive = isActive;

        return data;
      } catch (error) {
        console.error(`Erreur lors de la requête pour l'ID ${_id}:`, error);
        return null;
      }
    },
    async fetchOperations() {
      try {
        this.loadingOperations = true;
        const promises = this.operationsId.map((op) => this.fetchOperation(op._id));
        const results = await Promise.all(promises);

        // Filtrer les opérations actives
        this.operations = results.filter((op) => op && op.isActive);
        this.loadingOperations = false;
      } catch (error) {
        console.error("Erreur lors du chargement des opérations:", error);
        this.loadingOperations = false;
      }
    },
    getResult() {
      try {
        this.loadingState = true;
        let error = 0;

        for (let key of this.required_field) {
          if (!this.form[key] || this.form[key] == "") {
            this.error[key] = "Ce champ est requis";
            error++;
          }
        }
        if (error > 0) {
          this.loadingState = false;
          return;
        }

        let id = sessionStorage.getItem("_id");

        if (id == null) id = "n/a";

        if (error === 0) {
          var formDatas = {
            civilite: "Mr",
            operationId: this.operationId,
            nom: this.form.lastname,
            prenom: this.form.firstname,
            email: this.form.email,
            subid: this.subid,
            society: this.form.society,
            demande: this.idgame,
            operation: this.form.operation,
            objet: this.form.objet,
            message: this.form.message,
            idgame: this.idgame,
            type: "plateforme",
          };
          axios
            .post(
              `https://api.husqvarna-promo.fr/api/operations-custom/promodev-send-contact/sendmail`,
              formDatas
            )
            .then(() => {
              this.loadingState = false;
              this.dialogState = true;
              this.form = {};
              this.done = true;
            });
        } else {
          this.loadingState = false;
        }
      } catch (e) {
        console.log(e);
        this.loadingState = false;
      }
    },
  },
};
</script>

<style>
.contact .error_field input {
  border: 1px solid red;
  background-color: rgba(241, 214, 214, 0.819);
}

.contact .error {
  display: none !important;
  text-align: right !important;
  padding: 5px;
}
</style>
